import { render, staticRenderFns } from "./NewSwap.vue?vue&type=template&id=49e3a3d5&"
import script from "./NewSwap.vue?vue&type=script&lang=js&"
export * from "./NewSwap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports